import { Component, OnInit } from '@angular/core';
import { Hotel } from 'app/shared/model';
import { UtilService } from 'app/shared/util.service';
import { DateService } from 'app/shared/services/date.service';

@Component({
    selector: 'mh-prestay-section-trends',
    templateUrl: './prestay-section-trends.component.html',
    styleUrls: ['./prestay-section-trends.component.scss'],
    standalone: false
})
export class PrestaySectionTrendsComponent implements OnInit {

  productId=4;
  chainFilter: Hotel[] = [];
  isReady:boolean=false;

  fidelityPermisions:string[] = [];

  prefixTranslateFAQ = 'inter-chain.prestay.trends.faq';
  faqs = (new Array(1).fill(0));

  constructor(
    private utilService: UtilService,
    private dateService: DateService
  ) { }

  ngOnInit() {
    this.fidelityPermisions = this.utilService.getFidelityConfigurationsByProduct('interchain', 'interchain_prestay');
  }

  setChain(chain: Hotel[]) {
    // Igual que FollowUp corporativo: se aplaza porque el filtro de zona emite durante la detección de cambios
    setTimeout(() => {
      this.chainFilter = [...chain];
    }, 0);
  }

  dataIsReady(state){
    setTimeout(_ => {
      this.isReady = state;
    },200);
  }

  handleDatepickerUpdated($event) {
    this.dateService.setCurrentFilter($event.currentFilter);
    this.dateService.setCurrentDates($event.currentDates)
  }

  get currentDates() {
    return this.dateService.currentDates;
  }

  get currentFilterDate() {
    return this.dateService.currentFilter;
  }



}
